var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUnknown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 28
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.75 31.75V40h-1.5v-8.25h1.5zM40 27.252v1.5H16v-1.5h24zM28.75 16v11.25h-1.5V16h1.5z",
  fill: "#FFF"
}))));
export { SvgUnknown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NiIgaGVpZ2h0PSI1NiI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGN4PSIyOCIgY3k9IjI4IiByPSIyOCIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik0yOC43NSAzMS43NVY0MGgtMS41di04LjI1aDEuNXpNNDAgMjcuMjUydjEuNUgxNnYtMS41aDI0ek0yOC43NSAxNnYxMS4yNWgtMS41VjE2aDEuNXoiIGZpbGw9IiNGRkYiLz48L2c+PC9zdmc+";